import React from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 shadow">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Link to="/" className="text-purple-600 dark:text-purple-400 hover:underline text-sm mb-4 inline-block">
            ← Back to Home
          </Link>
          <div className="flex items-center">
            <Cookie className="h-8 w-8 text-purple-600 dark:text-purple-400 mr-3" />
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              Cookie Policy
            </h1>
          </div>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 space-y-8">
          
          {/* Introduction */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              Cookies and App Storage
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              Ajo does not use cookies for advertising or to track you across apps or websites. The web
              app stores authentication state and preferences in browser storage. The iOS app stores
              sign-in data in app storage. Third-party services may use their own cookies or similar
              storage when you access their features.
            </p>
          </section>

          {/* App storage */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              Storage Used by Ajo
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              Authentication state and user preferences are stored locally so the app can function.
              This storage is not used for advertising or cross-app tracking.
            </p>
          </section>

          {/* Managing Cookies */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              Managing Local Storage
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              You can clear locally stored data in your browser or remove the app from your device.
              This may sign you out or reset saved preferences.
            </p>
          </section>

          {/* Third-Party Services */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              Third-Party Services
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
              Third-party services used for support, sign-in, or payments may use their own cookies
              or similar storage when their features are accessed. Those services have their own
              privacy policies and storage practices.
            </p>
          </section>

          {/* Updates */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              Updates to This Policy
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              We may update this Cookie Policy from time to time to reflect changes in our practices or 
              for other operational, legal, or regulatory reasons. We encourage you to review this page 
              periodically for the latest information.
            </p>
          </section>

          {/* Contact */}
          <section className="border-t border-gray-200 dark:border-gray-700 pt-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              Contact Us
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
              If you have questions about our use of cookies, please contact us:
            </p>
            <div className="bg-purple-50 dark:bg-purple-900/20 rounded-lg p-4">
              <p className="text-gray-900 dark:text-white">
                <strong>Email:</strong>{' '}
                <a href="mailto:support@ajo.app" className="text-purple-600 dark:text-purple-400 hover:underline">
                  support@ajo.app
                </a>
              </p>
            </div>
          </section>

          {/* Related Links */}
          <section className="border-t border-gray-200 dark:border-gray-700 pt-8">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              Related Policies
            </h3>
            <div className="flex flex-wrap gap-3">
              <Link 
                to="/privacy" 
                className="px-4 py-2 bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 rounded-lg hover:bg-purple-200 dark:hover:bg-purple-900/50 transition-colors"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/termsandcondition" 
                className="px-4 py-2 bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 rounded-lg hover:bg-purple-200 dark:hover:bg-purple-900/50 transition-colors"
              >
                Terms & Conditions
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
